import './App.css'
import { Route, Routes, Navigate } from 'react-router-dom';
import ComingSoon from './page/ComingSoon';
import ContactPage from './page/ContactPage';
import Impressum from './page/Impressum';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;



function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<ComingSoon />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/impressum' element={<Impressum />} />
        {/* Redirect all other routes back to coming soon */}
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </>
  );
}

export default App;
